// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"310d478a","804":"06bd6b0c","977":"236f03d2"}[chunkId] + ".chunk.js";
};